<template>
  <BaseModal
    v-model="model"
    size="md"
    :title="title"
    :loading="loading"
    :cancel-button-disabled="loading"
    :confirm-button-disabled="loading"
    confirm-button-text="Importar"
    @confirm-button-click="handleImport"
  >
    <p
      v-if="description"
      class="text-center"
    >
      {{ description }}
    </p>
    <b-form-group
      label="Fichero"
      label-for="table-import-file"
    >
      <FileDropZone
        id="table-import-file"
        ref="import-file-input"
        :max-files="1"
        :accepted-extensions="acceptedExtensions"
        :param-name="paramName"
      />
    </b-form-group>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/ui/modal/BaseModal.vue'
import FileDropZone from '@/components/ui/file/FileDropZone.vue'

export default {
  name: 'TableImportModal',
  components: { BaseModal, FileDropZone },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Importar fichero',
    },
    description: {
      type: String,
      default: null,
    },
    paramName: {
      type: String,
      default: 'file',
    },
    acceptedExtensions: {
      type: String,
      default: 'text/csv,application/vnd.ms-excel,'
        + 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    getImportErrorMessage(error) {
      const data = error.response?.data
      if (data?.message) {
        return data.message
      }
      if (data?.error) {
        return data.error
      }

      const firstFieldError = Object.values(data || {}).find(value => Array.isArray(value))
      return firstFieldError?.[0]
    },
    async handleImport() {
      const files = this.$refs['import-file-input'].getFiles()
      if (files.length === 0) {
        this.$toast.error('Selecciona un fichero para importar.')
        return
      }

      this.loading = true
      try {
        const response = await this.$http.post(`/${this.resource}/import`, { [this.paramName]: files[0] })
        this.$refs['import-file-input'].removeAllFiles()
        this.model = false
        this.$toast(response.data?.message || 'Importación en proceso, recibirás un correo con el resultado.')
        this.$emit('imported', response.data)
      } catch (error) {
        this.$toast.error(this.getImportErrorMessage(error) || 'Ocurrió un error al importar el fichero. Por favor inténtelo de nuevo más tarde.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
